import { SYSTEM_EVENTS } from '@ezbobdev/ui-framework';

export const stepsNames = {
  applicationSummary: 'applicationSummary',
  termsAndConditions: 'termsAndConditions',
  privacyPolicy: 'privacyPolicy',
  consent: 'consent',
  aboutYourBusiness: 'aboutYourBusiness',
  directors: 'directors',
  applicantDetails: 'applicantDetails',
  aboutYou: 'aboutYou',
  aboutContributor: 'aboutContributor',
  aboutYouJointAccount: 'aboutYouJointAccount',
  aboutYouRetail: 'aboutYouRetail',
  previousAddress: 'previousAddress',
  sliders: 'sliders',
  requestAmount: 'requestAmount',
  financialDocuments: 'financialDocuments',
  beneficialOwners: 'beneficialOwners',
  beneficialOwnerStatement: 'beneficialOwnerStatement',
  beneficialOwnerStatementReject: 'beneficialOwnerStatementReject',
  referredPage: 'referredPage',
  thankYou: 'thankYou',
  congratulations: 'congratulations',
  rejectedPage: 'rejectedPage',
  caseExpired: 'caseExpired',
  cancel: 'cancel',
  selfDeclaredFinancialDetails: 'selfDeclaredFinancialDetails',
  idvConsent: 'idvConsent',
  financialInformation: 'financialInformation',
  error: 'error',
  completion: 'completion',
  referred: 'referred',
  rejected: 'rejected',
  idv: 'idv',
  idvSuccess: 'idvSuccess',
  idvError: 'idvError',
  eligibilityRejection: 'eligibilityRejection',
  documentSign: 'documentSign',
  bankAccountSelection: 'bankAccountSelection',
  rlsEligibility: 'rlsEligibility',
  inviteContributors: 'inviteContributors',
  vatLinking: 'vatLinking',
  ocrData: 'ocrData',
  loanAgreement: 'loanAgreement',
  accountConsent: 'accountConsent',
  partnerDetails: 'partnerDetails',
  accountPurpose: 'accountPurpose',
  accountCompliance: 'accountCompliance',
  activitiesAndProducts: 'activitiesAndProducts',
  accountApproval: 'accountApproval',
  approvePartnerDetails: 'approvePartnerDetails',
  creditCardType: 'creditCardType',
  applicationSummaryJointAccount: 'applicationSummaryJointAccount',
  approveActivities: 'approveActivities',
  thankYouJointAccount: 'thankYouJointAccount',
  voiceConsent: 'voiceConsent',
  bankLookup: 'bankLookup',
  aboutYouGreenlend: 'aboutYouGreenlend',
  scrollableConsent: 'scrollableConsent',
  voiceRecord: 'voiceRecord',
  idvAndSpeechToTextAreDone: 'idvAndSpeechToTextAreDone',
  otpSend: 'otpSend',
  otpVerification: 'otpVerification',
  welcomeWithConsent: 'welcomeWithConsent',
  aboutTheProcess: 'aboutTheProcess',
  kycQuestions: 'kycQuestions',
  uploadDocuments: 'uploadDocuments',
  ocrFeedback: 'ocrFeedback',
  ocrFeedbackStage2: 'ocrFeedbackStage2',
  ocrFeedbackStage3: 'ocrFeedbackStage3',
  thankYouSuccess: 'thankYouSuccess',
  welcome: 'welcome',
  howItWorks: 'howItWorks',
  firstStageCompletion: 'firstStageCompletion',
  occupationAndProfession: 'occupationAndProfession',
  employmentStatus: 'employmentStatus',
  questionnaire: 'questionnaire',
  referredPageDiscount: 'referredPageDiscount',
  guarantorInformation: 'guarantorInformation',
  addSignature: 'addSignature',
  markerIsNone: 'markerIsNone',
  extraIdentificationQuestion: 'extraIdentificationQuestion',
  identificationDetails: 'identificationDetails',
  firstNameLastName: 'firstNameLastName',
  otpPage: 'otpPage',
  otpLoanPage: 'otpLoanPage',
  avgMonthlyIncome: 'avgMonthlyIncome',
  businessOwnerIncome: 'businessOwnerIncome',
  secondStageCompletion: 'secondStageCompletion',
  contactDetails: 'contactDetails',
  preIdvState: 'preIdvState',
  preBeneficialState: 'preBeneficialState',
  creditLinePurpose: 'creditLinePurpose',
  creditLineRepaymentSource: 'creditLineRepaymentSource',
  completionPage: 'completionPage',
  initialOffer: 'initialOffer',
  nameJA: 'nameJA',
  activeCustomerPageJA: 'activeCustomerPageJA',
  idvOpeningPageJA: 'idvOpeningPageJA',
  au10tixJA: 'au10tixJA',
  scanovateJA: 'scanovateJA',
  scanovateRetryJA: 'scanovateRetryJA',
  au10tixBypassJA: 'au10tixBypassJA',
  authenticateIDJA: 'authenticateIDJA',
  confirmDetailsJA: 'confirmDetailsJA',
  addressPageJA: 'addressPageJA',
  userDetailsInEnglishCountryJA: 'userDetailsInEnglishCountryJA',
  accountPurposeJA: 'accountPurposeJA',
  statusOpeningPageJA: 'statusOpeningPageJA',
  statusCompanyJA: 'statusCompanyJA',
  detailsOfPartnerBJA: 'detailsOfPartnerBJA',
  statusCompanyPartnerBJA: 'statusCompanyPartnerBJA',
  combinedSalaryJA: 'combinedSalaryJA',
  kycOpeningPageJA: 'kycOpeningPageJA',
  incomeResourcesJA: 'incomeResourcesJA',
  expensesJA: 'expensesJA',
  initialDepositJA: 'initialDepositJA',
  otherActivitiesJA: 'otherActivitiesJA',
  productOpeningPageJA: 'productOpeningPageJA',
  productOpeningPageSecondAccountJA: 'productOpeningPageSecondAccountJA',
  accountTypeJA: 'accountTypeJA',
  uploadDocumentJA: 'uploadDocumentJA',
  chooseCommissionJA: 'chooseCommissionJA',
  branchJA: 'branchJA',
  insufficientCreditLimit: 'insufficientCreditLimit',
  loanSetupSuccess: 'loanSetupSuccess',
  welcomeRenewal: 'welcomeRenewal',
  servicesJA: 'servicesJA',
  singleApprovalJA: 'singleApprovalJA',
  deceasedPartnerJA: 'deceasedPartnerJA',
  selectCreditCardJA: 'selectCreditCardJA',
  noCardJA: 'noCardJA',
  declarationIsAmericanResidentPageJA: 'declarationIsAmericanResidentPageJA',
  declarationIsPublicFigurePageJA: 'declarationIsPublicFigurePageJA',
  declarationBeneficiaryStatementPageJA: 'declarationBeneficiaryStatementPageJA',
  recordingIntroJA: 'recordingIntroJA',
  recordingJA: 'recordingJA',
  recordingArabicMercJA: 'recordingArabicMercJA',
  signatureJA: 'signatureJA',
  closingJA: 'closingJA',
  bNameJA: 'bNameJA',
  bIdvOpeningPageJA: 'bIdvOpeningPageJA',
  bAu10tixJA: 'bAu10tixJA',
  bScanovateJA: 'bScanovateJA',
  bScanovateRetryJA: 'bScanovateRetryJA',
  bAu10tixBypassJA: 'bAu10tixBypassJA',
  bAuthenticateIDJA: 'bAuthenticateIDJA',
  bConfirmDetailsJA: 'bConfirmDetailsJA',
  bDetailsInEnglishCountryJA: 'bDetailsInEnglishCountryJA',
  bApprovalOfInputsJA: 'bApprovalOfInputsJA',
  bSelectCardJA: 'bSelectCardJA',
  bNoCardJA: 'bNoCardJA',
  bRecordingIntroJA: 'bRecordingIntroJA',
  bRecordingJA: 'bRecordingJA',
  bRecordingArabicMercJA: 'bRecordingArabicMercJA',
  bSignatureJA: 'bSignatureJA',
  bClosingJA: 'bClosingJA',
  exitPageJA: 'exitPageJA',
  offers: 'offers',
  lateLoanExists: 'lateLoanExists',
  editAddressJA: 'editAddressJA',
  verifyIdDetailsRetry: 'verifyIdDetailsRetry',
  confirmDetailsNoBackJA: 'confirmDetailsNoBackJA',
  bConfirmDetailsNoBackJA: 'bConfirmDetailsNoBackJA',
  declarationOpeningPageJA: 'declarationOpeningPageJA',
  branchTypeJA: 'branchTypeJA',
  branchNoBackJA: 'branchNoBackJA',
  servicesNoBackJA: 'servicesNoBackJA',
  benefitsJA: 'benefitsJA',
  bAddressPageJA: 'bAddressPageJA',
  bUploadDocumentJA: 'bUploadDocumentJA',
  bEditAddressJA: 'bEditAddressJA',
  bUploadDocumentPageJA: 'bUploadDocumentPageJA',
  bDeclarationOpeningPageJA: 'bDeclarationOpeningPageJA',
  bDeclarationIsAmericanResidentPageJA: 'bDeclarationIsAmericanResidentPageJA',
  bDeclarationIsPublicFigurePageJA: 'bDeclarationIsPublicFigurePageJA',
  bDeclarationBeneficiaryStatementPageJA: 'bDeclarationBeneficiaryStatementPageJA',
  bApprovalOpeningPageJA: 'bApprovalOpeningPageJA',
  aboutYourBusinessBA: 'aboutYourBusinessBA',
  financialsAndKYB: 'financialsAndKYB',
  errorPageJA: 'errorPageJA',
  mandate: 'mandate',
  eventDate: 'eventDate',
  instalmentDay: 'instalmentDay',
  companyRoleQuestionaire: 'companyRoleQuestionaire',
  companyNumber: 'companyNumber',
  addressDetails: 'addressDetails',
  companyDetails: 'companyDetails',
  numberOfEmployees: 'numberOfEmployees',
  finalOfferAmount: 'finalOfferAmount',
  uploadESNADocumentsStage2: 'uploadESNADocumentsStage2',
  improveOffer: 'improveOffer',
  uploadESNADocumentsStage3: 'uploadESNADocumentsStage3',
  rejectionCompanyRole: 'rejectionCompanyRole',
  idvFailed: 'idvFailed',
  entityType: 'entityType',
  loanPurpose: 'loanPurpose',
  instalmentDetails: 'instalmentDetails',
  instalmentSlider: 'instalmentSlider',
  idDetailsRetry: 'idDetailsRetry',
  au10tixRetryJA: 'au10tixRetryJA',
  bAu10tixRetryJA: 'bAu10tixRetryJA',
  identificationItalian: 'identificationItalian',
  identificationDetailsExist: 'identificationDetailsExist',
  addBankAccount: 'addBankAccount',
  selectUploadOrOpenBanking: 'selectUploadOrOpenBanking',
  otpSignatureForLoanAgreement: 'otpSignatureForLoanAgreement',
  offerDetailsChanged: 'offerDetailsChanged',
  applicationSummaryUploadDocFunnel: 'applicationSummaryUploadDocFunnel',
  signedLoanAgreement: 'signedLoanAgreement',
  creditRuleReject: 'creditRuleReject',
  initialOfferRenewal: 'initialOfferRenewal',
  applicationSummaryRenewal: 'applicationSummaryRenewal',
  addSignatureRenewal: 'addSignatureRenewal',
  completionPageRenewal: 'completionPageRenewal',
  renewalIdentificationDetails: 'renewalIdentificationDetails',
  renewalIdentificationFailed: 'renewalIdentificationFailed',
  creditBureauLimitReached: 'creditBureauLimitReached',
  creditCardLimitJA: 'creditCardLimitJA',
  bCreditCardLimitJA: 'bCreditCardLimitJA',
  creditReportOpeningJA: 'creditReportOpeningJA',
  bCreditReportOpeningJA: 'bCreditReportOpeningJA',
  cashAccountLimitJA: 'cashAccountLimitJA',
  bCashAccountLimitJA: 'bCashAccountLimitJA',
  cashAccountLimitNoBackJA: 'cashAccountLimitNoBackJA',
  bCashAccountLimitNoBackJA: 'bCashAccountLimitNoBackJA',
  creditConsentJA: 'creditConsentJA',
  bCreditConsentJA: 'bCreditConsentJA',
  finalCreditReportJA: 'finalCreditReportJA',
  bFinalCreditReportJA: 'bFinalCreditReportJA',
  finalCreditReportNoLinkJA: 'finalCreditReportNoLinkJA',
  bFinalCreditReportNoLinkJA: 'bFinalCreditReportNoLinkJA',
  bnplDisclosure: 'bnplDisclosure',
  validitAIExam: 'validitAIExam',
  bankAccountDetails: 'bankAccountDetails',
};

export const businessType = {
  soleTrader: 'SOLE_TRADER',
  limitedCompany: 'LIMITED_COMPANY',
  partnership: 'PARTNERSHIP',
};

export const entityType = {
  personal: 'Personal',
  company: 'Company',
  soleTrader: 'Sole trader',
};

export const helpType = {
  page: 'page',
  modal: 'modal',
  popover: 'popover',
};

export const wizardDirection = {
  forward: 'FORWARD',
  forwardSecondary: 'FORWARD_SECONDARY',
  backward: 'BACKWARD',
};

export const pageActionType = {
  logout: 'logout',
  redirect: 'redirect',
  newTab: 'newTab',
  event: 'event',
  progress: 'progress',
};

export const rumActionType = {
  progress: 'progress',
  failurePointTextMissing: 'failurePointTextMissing',
};

export const systemEvents = {
  ...SYSTEM_EVENTS,
  DECISION_REJECTED: 'DECISION_REJECTED',
  DECISION_APPROVED: 'DECISION_APPROVED',
  DECISION_REFERRED: 'DECISION_REFERRED',
  CLIENT_CASE_EXPIRED: 'CLIENT_CASE_EXPIRED',
  SESSION_TERMINATED: 'SESSION_TERMINATED',
  LOAN_CREATED: 'LOAN_CREATED',
  ERROR: 'ERROR',
  FLOW_LEAD: 'FLOW_LEAD',
  FLOW_FINISHED: 'FLOW_FINISHED',
  KYC_OPENING_PAGE_LOAD: 'KYC_OPENING_PAGE_LOAD',
  PRODUCT_OPENING_PAGE_LOAD: 'PRODUCT_OPENING_PAGE_LOAD',
  MARKER_IS_NONE_BULLET: 'MARKER_IS_NONE_BULLET',
  GL_FLOW_COMPLETED: 'GL_FLOW_COMPLETED',
  GL_ABANDON: 'GL_ABANDON',
};

export const recordingDocType = {
  SPEECH_TO_TEXT_SENTENCE_COMPARISON: 'SPEECH_TO_TEXT_SENTENCE_COMPARISON',
  BENEFICIAL_OWNER_CONSENT: 'BENEFICIAL_OWNER_CONSENT',
};

export const docType = {
  BANK: 'BANK',
  SIGNATURE_IMAGE: 'SIGNATURE_IMAGE',
};

export const docSubType = {
  SIGNATURE_DOCUMENT: 'SIGNATURE_DOCUMENT',
};

export const occupationStatus = {
  EMPLOYEE: 'Employee',
};

export const occupationSubStatus = {
  OTHER: 'Other',
};

export const incomeTypes = {
  ABROAD: 'IncomeTypeAbroad',
};

export const expenseTypes = {
  ABROAD: 'ExpenseAbroad',
};

export const FlowTypes = {
  CONTRIBUTOR: 'CONTRIBUTOR',
};

export const feeTracks = {
  NO_PACKAGE: 'NoPackage',
};

export const branchTypes = {
  PHYSICAL: 'physical',
  DIGITAL: 'digital',
};

// ids for accessibility
export const accessibilityIds = {
  titleId: 'titleId',
  buttonId: 'buttonId',
};

// values stored in applicant.custom.selectedCards by SelectCreditCardJA; the BE matches the same strings
export const cardOrderValues = {
  isCreditCardOrder: 'isCreditCardOrder',
  isDebitCardOrder: 'isDebitCardOrder',
  isRechargeableCardOrder: 'isRechargeableCardOrder',
};
